import { render } from "./PayerTable.vue?vue&type=template&id=973465dc"
import script from "./PayerTable.ts?vue&type=script&lang=js&external"
export * from "./PayerTable.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__